import { Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import fr from 'date-fns/locale/fr';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { faCheck, faInfoCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dataApplicationsContext from '../context/dataApplicationsContext';

function FormDate({ 
  control, setValue, nameInput, label, labelClass, dateClass, dateContainerClass, holidays, competition, minDate, noTime, tooltip, noTooltip,
  noReset, errors, clearErrors, labelLong, isRange, dateRange, setDateRange, placeholder, disabled, watch, requireMessage, 
  errorClass, nameDebut, nameFin, accurateError, noSmallDeviceClass
}) {
  const { windowWidth } = useContext(dataApplicationsContext);
  const [isOpen, setIsOpen] = useState(false); // État pour gérer l'ouverture/fermeture
  const isSmallDevice = windowWidth < 1021;
  const [selectedMonth, setSelectedMonth] = useState(minDate ? new Date(minDate) : new Date()); // Mois voulu
  const [startDate, setStartDate] = useState(null); // Nouvel état pour stocker la date de début

  const minDateValue = minDate ? new Date(minDate) : new Date();

  const handleStartDateChange = (date) => {
    if (isRange) {
      setDateRange(date);
    } else {
      setStartDate(date); // Mettre à jour l'état avec la date de début
      setValue(nameInput, date); // Mettre à jour la valeur de début
      //  TODO nameFin && !watch(nameFin) Rajouter ou si datefin is before dateDebut
      (nameFin && !watch(nameFin)) && setValue(nameFin, date); // Mettre à jour la valeur de fin avec la même valeur que début
    }
  };

  const generateHolidayDates = (beginDate, endDate) => {
    const holidayDates = [];
    let currentDate = new Date(beginDate);
    let currentendDate = new Date(endDate);
    while (currentDate <= currentendDate) {
      holidayDates.push({date: new Date(currentDate)});
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return holidayDates;
  };
  const holidayDates = competition && generateHolidayDates(competition.begin, competition.end);

  const ExampleCustomInput = forwardRef(
    ({ value, onClick, className, placeholder }, ref) => {
      const isPlaceholder = !value;
      const color = isPlaceholder ? 'color-gray-7 fw-300' : 'color-blackPrimary fw-500';

      return ( 
        <button className={className + ' ' + color} onClick={onClick} ref={ref}>
          {value || placeholder}
        </button>
      )
    },
  );

  const handleMonthChange = (e, changeMonthFn) => {
    e.preventDefault();
    e.stopPropagation();
    changeMonthFn();
  };


  useEffect(() => {
    // Quand le calendrier est ouvert, on ajuste le mois à afficher
    if (nameInput === nameFin && watch(nameDebut)) {
      setSelectedMonth(new Date(watch(nameDebut)));
    } else if (isOpen && minDate) {
      setSelectedMonth(new Date(minDate));
    }
  }, [isOpen, minDate]);


  
  return (
    <div className={`${dateContainerClass} ${(isSmallDevice && !noTime) ? 'small-device-noTime-container' : ''}`}>
      <div className="d-flex mb-2">
        <label htmlFor={nameInput} className={labelClass}>{label}</label>
      </div>
      {/* {errors && errors[nameInput] && <p className="instruction register-compet-instruction mb-4 mt-4">{errors[nameInput]?.message}</p>} */}
      <Controller
        name={nameInput}
        control={control}
        defaultValue={null} // La valeur initiale de votre champ
        rules={{ required: requireMessage || 'Ce champ est obligatoire' }} // Ajout de la validation required
        render={({ field }) => (
          <DatePicker
            locale={fr} 
            startDate={isRange ? dateRange[0] : null}
            endDate={isRange ? dateRange[1] : null}
            selected={!isRange ? field.value : null}
            onChange={(date) => {
              field.onChange(date);
              handleStartDateChange(date);
              clearErrors(nameInput); // Efface les erreurs lorsque la date change
            }} // Gérer le changement de date de début
            showTimeSelect={!noTime} 
            withPortal={isSmallDevice} 
            className={`${dateClass} ${((errors && errors[nameInput]) || accurateError) ? ' error-border' : ''} ${(isSmallDevice && !noSmallDeviceClass) ? 'w-80p' : ''}`}
            timeIntervals={5}
            selectsRange={isRange} 
            dateFormat={noTime ? "dd/MM/yyyy" : "dd/MM/yyyy  à  HH:mm"} 
            // filterTime={filterPassedTime} 
            // minDate={new Date(minDateValue)}
            // Désactiver les dates avant la date de début
            minDate={nameInput === nameFin ? new Date(watch(nameDebut)) : null}
            holidays={holidays ? holidayDates : []}
            placeholderText={placeholder ?? `JJ/MM/AAAA${!noTime ? '  à  hh:mm' : ''}`}
            isClearable={!noReset && !isSmallDevice}
            onCalendarOpen={() => setIsOpen(true)} // Détecte l'ouverture de la popup
            onCalendarClose={() => setIsOpen(false)} // Détecte la fermeture de la popup
            customInput={isSmallDevice ? <ExampleCustomInput className="custom-input-datePicker" /> : null}
            renderCustomHeader={({ date, decreaseMonth, increaseMonth, changeMonth, monthDate, }) => (
              <div className={`custom-modal-header ${isSmallDevice ? '' : 'pt-0'}`}>
                {isSmallDevice && <p className={'header-date-picker-label'}>{labelLong ?? label}</p>}
                <div className="month-navigation">
                  <i className={`bi bi-chevron-left fz-18 cursor-pointer`} onClick={(e) => handleMonthChange(e, decreaseMonth)}></i>
                  <p className="month-display">{new Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric' }).format(date)}</p>
                  <i className={`bi bi-chevron-right fz-18 cursor-pointer`} onClick={(e) => handleMonthChange(e, increaseMonth)}></i>
                </div>
              </div>
            )}
            // Permet de définir le mois affiché par défaut
            openToDate={selectedMonth}
          />
        )}
      />
      {errors && errors[nameInput] && 
        <p className={`instruction register-compet-instruction ${errorClass ?? 'mb-4 mt-4'}`}>
          <FontAwesomeIcon icon={faInfoCircle} />{errors[nameInput]?.message}
        </p>
      }
      {/* {<i className={`bi bi-calendar3-week calendar-icon ${noReset ? 'right-16' : ''}`}></i>} */}
      {(isOpen && !isSmallDevice) && <div className="bg-modal-picker"></div>}
    </div>
  )
}

export default FormDate